module.exports = __webpack_public_path__ + "static/media/empty-user-img2.3bc29ac3.svg";